import React from "react";

const ContactlessOptionsBus = (props) => {
  const options = [
    {
      text: 'J’ai de la difficulté avec mon terminal. Pouvez-vous m’aider?',
      handler: props.actionProvider.ContactlessBus1,
      id: 1
    },
    {
      text: 'Paiements sans contact et par puce et NIP par Débit INTERAC?',
      handler: props.actionProvider.ContactlessBus2,
      id: 2
    },
    {
      text: 'J’ai déjà Débit INTERAC. Ai-je besoin d’un nouveau terminal si je veux commencer à offrir Flash INTERAC?',
      handler: props.actionProvider.ContactlessBus3,
      id: 3
    },
    {
      text: 'Les frais pour les paiements sans contact sont-ils les mêmes que pour les paiements par puce et NIP?',
      handler: props.actionProvider.ContactlessBus4,
      id: 4
    },
    {
      text: 'Quelles sont mes obligations en matière de fraude relativement à Flash INTERAC?',
      handler: props.actionProvider.ContactlessBus5,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default ContactlessOptionsBus;